module.exports = __webpack_public_path__ + "static/media/szlahu_orange_hor.84317c3a.svg";